/**
 * export
 */
export class ExportInfo {
  exportType: ExportType;
  startDate: Date;
  endDate: Date;
  sites: number[];
  statesProject: number[];
  status: string[];
  allSites: boolean;
  allStatus: boolean;
  customerAccountId: number;
  eventId: number;
  commercialId: number;
  commercialIds: number[] = [];

  constructor() {
    this.allSites = true;
    this.allStatus = true;
    this.commercialId = null;
  }
}

/**
 * export types
 */
export enum ExportType {
  state_projects_by_states = "state_projects_by_states",
  state_projects = "state_projects",
  state_tasks = "state_tasks",
  followed_projects = "followed_projects",
  followed_projects_daily = "followed_projects_daily",
  daily_global_commercial_activities = "daily_global_commercial_activities",
  followed_projects_by_commercial = "followed_projects_by_commercial",
  customers_by_commercial = "customers_by_commercial",
  articles_template = "articles_template",
  tiers_template = "tiers_template",
  states_template = "states_template",
  projects_template = "projects_template",
  lotissements_template = "lotissements_template",
  pointOfSales_template = "pointOfSales_template",
  customers_accounts = "customers_accounts",
  appointment_notification_history = "appointment_notification_history",
  decision_notification_history = "decision_notification_history",
  event_visitors = "event_visitors",
  //concours_architecturaux_template = "concours_architecturaux_template",
}

/**
 * import manager
 */
export enum ImportType {
  articles = "articles",
  tiers = "tiers",
  states = "states",
  projects = "projects",
  lotissements = "lotissements",
  pointOfSales = "pointOfSales",
  //concoursArchitecturaux = "concoursArchitecturaux",
}

export class ImportManager {
  importType: ImportType;
  title: string;
  societyId: number;

  constructor() {}
}

/**
 * ImportType to ExportType mapping
 */
export function ImportTypetoExportType(importType: ImportType): ExportType {
  switch (importType) {
    case ImportType.articles:
      return ExportType.articles_template;
    case ImportType.tiers:
      return ExportType.tiers_template;
    case ImportType.states:
      return ExportType.states_template;
    case ImportType.projects:
      return ExportType.projects_template;
    case ImportType.lotissements:
      return ExportType.lotissements_template;
    case ImportType.pointOfSales:
      return ExportType.pointOfSales_template;
    /*case ImportType.concoursArchitecturaux:
      return ExportType.concours_architecturaux_template;*/

    default:
      return null;
  }
}
